const LoadingState = () => {
  return (
    <div className="min-h-screen bg-silver-mist py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {/* Header skeleton */}
          <div className="flex items-center justify-between">
            <div className="h-8 w-64 bg-steel/20 loading-skeleton"></div>
            <div className="h-10 w-32 bg-steel/20 loading-skeleton"></div>
          </div>

          {/* Filter/search skeleton */}
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="h-10 flex-1 bg-steel/20 loading-skeleton"></div>
            <div className="h-10 w-40 bg-steel/20 loading-skeleton"></div>
            <div className="h-10 w-32 bg-steel/20 loading-skeleton"></div>
          </div>

          {/* Cards skeleton */}
          <div className="grid gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-crystal-white border border-silver-mist p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1 space-y-3">
                    <div className="h-5 w-32 bg-steel/20 loading-skeleton"></div>
                    <div className="h-4 w-48 bg-steel/20 loading-skeleton"></div>
                  </div>
                  <div className="h-6 w-20 bg-steel/20 loading-skeleton"></div>
                </div>
                <div className="grid grid-cols-3 gap-4 mb-4">
                  <div className="h-4 bg-steel/20 loading-skeleton"></div>
                  <div className="h-4 bg-steel/20 loading-skeleton"></div>
                  <div className="h-4 bg-steel/20 loading-skeleton"></div>
                </div>
                <div className="flex justify-end space-x-2">
                  <div className="h-8 w-24 bg-steel/20 loading-skeleton"></div>
                  <div className="h-8 w-20 bg-steel/20 loading-skeleton"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
